export const getToken = () => localStorage.getItem("token")
export const isAuthenticated = () => !!getToken()
export const getUserId = () => localStorage.getItem("user_id")
export const signIn = (token, userId) => {
  localStorage.setItem("token", token)
  localStorage.setItem("user_id", userId)
  if (window.Intercom) window.Intercom("shutdown")
}
export const signOut = () => {
  localStorage.removeItem("token")
  localStorage.removeItem("user_id")
  if (window.Intercom) {
    window.Intercom("shutdown")
    window.Intercom("boot", {
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
    })
  }
}

export const DASHBOARD_LAYOUT = { RETAIL: "retail", RESTAURANT: "restaurant" }
